import React from 'react';
import PropTypes from 'prop-types';

function LeftArrow({ active, activeColor, color }) {
  return (
    <path
      d="M139.071 226.102V205.127C139.071 201.259 142.207 198.122 146.076 198.122H164.407C166.265 198.122 168.046 198.86 169.36 200.174L179.527 210.34C182.262 213.076 182.262 217.511 179.527 220.247L169.024 230.748C167.74 232.033 166.007 232.768 164.191 232.8L146.196 233.106C142.28 233.173 139.071 230.018 139.071 226.102Z"
      fill={active ? activeColor : color}
    />
  );
}

LeftArrow.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

LeftArrow.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#4F535E',
};

export default LeftArrow;
